<template>
  <q-card-actions v-bind="$attrs">
    <slot></slot>
  </q-card-actions>
</template>
